import React from "react";
import AnnouncementBar from "../components/AnnouncementBar";
import Header from "../components/Header";
import HeroCarousel from "../components/HeroCarousel";
import HeroActions from "../components/HeroActions";
import ReviewsMarquee from "../components/ReviewsMarquee";
import BestSellers from "../components/BestSellers";
import HairProblems from "../components/HairProblems";
import HairQuiz from "../components/HairQuiz";
import Testimonials from "../components/Testimonials";
import BeforeAfter from "../components/BeforeAfter";
import AIHairAnalysis from "../components/AIHairAnalysis";
import WhatsAppGroup from "../components/WhatsAppGroup";
import Collections from "../components/Collections";
import AffiliateSection from "../components/AffiliateSection";
import RecentReviews from "../components/RecentReviews";
import BlogSection from "../components/BlogSection";
import FounderQuote from "../components/FounderQuote";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#FBF8F4]">
      <AnnouncementBar />
      <Header />
      <HeroCarousel />
      <HeroActions />
      <ReviewsMarquee />
      <BestSellers />
      <HairProblems />
      <HairQuiz />
      <Testimonials />
      <BeforeAfter />
      <AIHairAnalysis />
      <WhatsAppGroup />
      <Collections />
      <AffiliateSection />
      <RecentReviews />
      <BlogSection />
      <FounderQuote />
      <Footer />
    </div>
  );
}
